import './assets/App.css';
import './pages/Home'
import Home from './pages/Home';
import Blog from './pages/Blog';
import ERA2025 from './blogs/ERA2025';
import PreActionCampaign from './pages/PreActionCampaign';
import {BrowserRouter,Route,Routes} from 'react-router-dom'

function App() {
  return (
    <div className="App">
      <BrowserRouter>
      <Routes>
      <Route path='/' element={<Home/>}/>
      <Route path="/nlj-briefing" element={<PreActionCampaign />} />
      <Route path='/blog' element={<Blog/>}/>
      <Route path='/blog/Beyond-the-April-Horizon-What-ERA-2025-Demands-of-Employment-Practitioners-Right-Now' element={<ERA2025/>}/>
      </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
